module.exports = __webpack_public_path__ + "static/media/gly.4756a725.gif";